import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGreenShieldIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 22",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#0CCE6B",
		d: "m8.188.361-7 3.111A2 2 0 0 0 0 5.3V10c0 7.83 6.439 11.486 9 12 2.561-.514 9-4.17 9-12V5.3a2 2 0 0 0-1.188-1.828l-7-3.111a2 2 0 0 0-1.624 0m-.895 14.346-2.77-2.77a1 1 0 0 1 1.414-1.414L8 12.586l5.085-5.085a1 1 0 0 1 1.414 1.414l-5.792 5.792a1 1 0 0 1-1.414 0"
	})
});
export default SvgGreenShieldIcon;
